import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs';
import toastr from 'toastr';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log('entro no guard');
    if (localStorage.getItem('user')) {
      return true;
    }
    this.router.navigate(['auth']); // caso nao esta logado redirect para login
    toastr.error('Acesso não autorizado');
    return false;

  }
}
